module.exports = __webpack_public_path__ + "static/media/ponchos.6570c0a5.png";